/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol, Button, NumberField } from 'sarsaparilla';

const propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    isLabelRequired: PropTypes.bool,
    isInvalid: PropTypes.bool,
};

export default function TempForm(props) {
    return (
        <FlexRow alignItems="end">
            <FlexCol xs="variable" className="ml-2">
                <NumberField
                    id="simple-form-number"
                    units="dates"
                    visualLabel="Number of dates"
                    visualLabelPosition="top"
                    isRequired={props.isLabelRequired}
                    min={props.minValue}
                    max={props.maxValue}
                    value={props.value}
                    isInvalid={props.isInvalid}
                    onChange={(value) => props.onChange(value)}
                />
            </FlexCol>
            <FlexCol>
                <Button onClick={props.onSubmit}>Enter Choices</Button>
            </FlexCol>
        </FlexRow>
    );
}

TempForm.defaultProps = {
    maxValue: 99,
    minValue: 0,
    isLabelRequired: false,
};

TempForm.propTypes = propTypes;
